var React = require('react');
const costMappings = JSON.parse(document.getElementById('cost-mappings').getAttribute('data_value'));;

class SimpleNutritionAccordion extends React.Component {

    constructor() {
        super();
        this.state = {
            open: false
        }
        this.onClick = this.onClick.bind(this);
        this.contents = this.contents.bind(this);
        this.checkboxClick = this.checkboxClick.bind(this);
    }

    onClick(e) {
        this.props.actions.clickAccordion(this.props.index, e.target.checked)
        this.setState({open: !this.state.open})
    }

    checkboxClick(inputName, e) {
        this.props.actions.checkInput(this.props.index, inputName, e.target.checked)
    }

    contents() {
        if (this.state.open) {
            return (
                <div className='accordion-contents'>
                    <div>
                        <input
                            className="user-checkbox big-checkbox"
                            id="simple_nutrition__carbohydrates"
                            value="simple_nutrition__carbohydrates"
                            type="checkbox"
                            name={`option-${this.props.index}[]`}
                            onClick={(e) => {
                                this.checkboxClick('simple_nutrition__carbohydrates', e);
                            }}
                        />
                        <span className="option-label">Carbohydrates (<span
                            className="dollar">$</span>{costMappings['simple_nutrition__carbohydrates']})</span>
                    </div>
                    <div>
                        <input
                            className="user-checkbox big-checkbox"
                            id="simple_nutrition__protein"
                            value="simple_nutrition__protein"
                            type="checkbox"
                            name={`option-${this.props.index}[]`}
                            onClick={(e) => {
                                this.checkboxClick('simple_nutrition__protein', e);
                            }}
                        />
                        <span className="option-label">Protein (<span
                            className="dollar">$</span>{costMappings['simple_nutrition__protein']})</span>
                    </div>
                    <div>
                        <input
                            className="user-checkbox big-checkbox"
                            id="simple_nutrition__sugar"
                            value="simple_nutrition__sugar"
                            type="checkbox"
                            name={`option-${this.props.index}[]`}
                            onClick={(e) => {
                                this.checkboxClick('simple_nutrition__sugar', e);
                            }}
                        />
                        <span className="option-label">Sugar (<span
                            className="dollar">$</span>{costMappings['simple_nutrition__sugar']})</span>
                    </div>
                    <div>
                        <input
                            className="user-checkbox big-checkbox"
                            id="simple_nutrition__polyphenols"
                            value="simple_nutrition__polyphenols"
                            type="checkbox"
                            name={`option-${this.props.index}[]`}
                            onClick={(e) => {
                                this.checkboxClick('simple_nutrition__polyphenols', e);
                            }}
                        />
                        <span className="option-label">Polyphenols (<span
                            className="dollar">$</span>{costMappings['simple_nutrition__polyphenols']})</span>
                    </div>
                    <div>
                        <input
                            className="user-checkbox big-checkbox"
                            id="simple_nutrition__starch"
                            value="simple_nutrition__starch"
                            type="checkbox"
                            name={`option-${this.props.index}[]`}
                            onClick={(e) => {
                                this.checkboxClick('simple_nutrition__starch', e);
                            }}
                        />
                        <span className="option-label">Starch (<span
                            className="dollar">$</span>{costMappings['simple_nutrition__starch']})</span>
                    </div>
                </div>
            )
        }

    }

    render() {
        return (
            <div className="accordion simple_nutrition">
                <div onClick={this.onClick}>
                    <input type='checkbox' className="user-checkbox big-checkbox" checked={this.state.open} />
                    <span className='option-label'>Simple Nutrition <small><i>(Check to see options)</i></small>
                    </span>
                </div>
                {this.contents()}
            </div>
        );
    }
}

export default SimpleNutritionAccordion